import React from "react";
import PropTypes from "prop-types";
import { Box, IconButton, LinearProgress, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import { PdfIcon } from "../../../utils/Icons";
import "./UIUploadProgress.scss";

const UIUploadProgress = ({
  fileName,
  preview,
  isPdf,
  progress,
  label,
  onRemove,
}) => {
  const hasImagePreview =
    typeof preview === "string" &&
    (preview.startsWith("data:image") || /^https?:\/\//.test(preview));

  return (
    <Box className="ui-upload-progress" aria-busy="true" aria-live="polite">
      {onRemove && (
        <IconButton
          type="button"
          className="ui-upload-progress__remove"
          aria-label="Remove file"
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            onRemove();
          }}
        >
          <CloseIcon />
        </IconButton>
      )}
      {hasImagePreview ? (
        <Box
          className="ui-upload-progress__preview"
          sx={{ backgroundImage: `url(${preview})` }}
        />
      ) : isPdf ? (
        <PdfIcon className="ui-upload-progress__file-icon" />
      ) : (
        <InsertDriveFileOutlinedIcon className="ui-upload-progress__file-icon" />
      )}
      <Typography className="ui-upload-progress__file-name">
        {fileName || label}
      </Typography>
      <LinearProgress
        className="ui-upload-progress__bar"
        variant={typeof progress === "number" ? "determinate" : "indeterminate"}
        value={typeof progress === "number" ? progress : undefined}
      />
    </Box>
  );
};

UIUploadProgress.propTypes = {
  fileName: PropTypes.string,
  preview: PropTypes.string,
  isPdf: PropTypes.bool,
  progress: PropTypes.number,
  label: PropTypes.node,
  onRemove: PropTypes.func,
};

UIUploadProgress.defaultProps = {
  fileName: "",
  preview: "",
  isPdf: false,
  progress: undefined,
  label: "Uploading file",
  onRemove: undefined,
};

export default UIUploadProgress;
